import React from 'react'

const SidebarToggleIcon = (props) => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect
        x='2.5'
        y='3.5'
        width='15'
        height='13'
        rx='3.5'
        stroke='currentColor'
        strokeWidth='1.5'
      />
      <path
        d='M7.5 3.5V16.5'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    </svg>
  )
}

export default SidebarToggleIcon
